module.exports = __webpack_public_path__ + "img/Arrow - Left.e7d4f2d8.svg";